import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    technologycategoryList: [],
    technologycategory: null,
    links: null,
    meta: null,
    filter: {
      keyword: '',
      status: '',
    },
  },

  mutations: {
    CLEAR_ALL(state) {
      state.technologycategoryList = [];
      state.technologycategory = null;
    },
    SET_TECHNOLOGYCATEGORYLIST(state, data) {
      state.technologycategoryList = data.data.map(
        (item) => {
          item.isChecked = false;
          return item;
        },
      );
      state.links = data.links;
      state.meta = data.meta;
    },
    SET_TECHNOLOGYCATEGORY(state, data) {
      state.technologycategory = data;
    },
    SET_FILTER(state, data) {
      state.filter = data;
    },
    SET_META(state, data) {
      state.meta = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setFilter({ commit }, data) {
      commit('SET_FILTER', data);
    },

    setMeta({ commit }, data) {
      commit('SET_META', data);
    },

    setTechnologyCategory({ commit }, data) {
      commit('SET_TECHNOLOGYCATEGORY', data);
    },

    find({ commit, state }) {
      let url = `/tech-category?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('technologycategory'));
          return response.body;
        })
        .then((response) => {
          commit('SET_TECHNOLOGYCATEGORYLIST', response);
        });
    },

    findById({ commit }, id) {
      return http(`/tech-category/${id}`)
        .then((response) => response.body)
        .then(typeAs('technologycategory'))
        .then((item) => {
          commit('SET_TECHNOLOGYCATEGORY', item);
        });
    },

    destroy(_, id) {
      return http(`/tech-category/${id}`, { method: 'DELETE' })
        .then((response) => response.body);
    },

    save(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/tech-category/${id}`, { method: 'PUT', data })
        : http('/tech-category', { method: 'POST', data });
      console.log(data);
      return request.then((response) => response.body);
    },

    changeStatus(_, {
      id, ...data
    }) {
      const request = http(`/tech-category/${id}/status`, { method: 'PUT', data });

      return request.then((response) => response.body);
    },
  },
};
